export const THUMBNAIL_STATUS = {
  SUCCESS: 'SUCCESS',
  RENDERING: 'RENDERING',
  ERROR: 'ERROR',
};
